<template>
  <!-- <div>
    <el-dialog title="切换公司" :visible.sync="$store.state.switchCompanyDialog" :close-on-click-modal="false"
               width="45%" center
               top="3%"> -->
      <div class="dialog_warp">
        <div class="dialog_form g-glun">
          <ul class="g-handle-type">
            <li v-for="(item,index) in companyIcList" :key="index" class="list-item" @click="getAdminInfo(item,index)" :class="companyId == item.companyId ? 'p-active':'p-disabled'">
              <h3>{{item.companyName}}</h3>
            </li>
          </ul>
        </div>
        <div class="text-center">
          <el-button type="success" size="mini" @click="examineInvestment">确定</el-button>
        </div>
      </div>
    <!-- </el-dialog>
  </div> -->
</template>

<script>
  import * as getData from '../service/getData'
  import * as global from '../config/mUtils'

  export default {
    data() {
      return {
        // companyIcList: [],
        companyId: '',
      }
    },
    props: ['companyIcList'],
    created() {
    },
    mounted() {
      this.companyId = sessionStorage.getItem('companyId') || '';
    },
    methods: {
      getAdminInfo(item,index){
        this.companyId = item.companyId;
      },
      examineInvestment(){//切换账号公司
        getData.chooseCompany({companyId:this.companyId}).then((res) => {
          if (res.data.code != 1) {
            this.$message.error(res.data.message);
            return;
          }
          sessionStorage.setItem('companyId', this.companyId);
          this.$emit('closeDialog');
        }).catch(_ => {
        })
      }
    },
  }
</script>

<style lang="scss" scoped>
  .list-item{
    border: 1px solid #ccc;
    margin-top: 20px;
    cursor: pointer;
    &:hover {
        background-color: #e4f4fa;
      }
    h3{
      font-weight: 500;
      font-style: normal;
      font-size: 16px;
      line-height: 56px;
      margin-left: 10px;
    }
  }
  .g-height-flexd{
    height: 400px;
    overflow: auto;
    padding-right: 20px;
  }
  .flex-col{
    display: flex;
    flex-direction: column;
  }
  .building_index {
    background: #ecf3f9;
    padding: 10px 20px;
    box-sizing: border-box;
  }

  .center_nav {
    /*background: #fff;*/
    li {
      margin-left: 20px;
      padding: 9px 20px;
      cursor: pointer;
      text-align: center;
      border-bottom: 4px solid rgba(255, 255, 255, 0);
    }
    .active {
      border-bottom: 4px solid #0BABF7;
      color: #0BABF7;
    }
    li:first-child {
      margin-left: 0;
    }
  }

  .nav {
    width: 100%;
    background: #fff;
    display: flex;
    justify-content: space-between;
    padding: 10px 20px 0 30px;
    box-sizing: border-box;
    .building_btn {
    }
  }

  .building_table {
    position: relative;
    .position_date_parker {
      background: #fff;
      position: absolute;
      z-index: 10000;
      left: 50%;
      top: 50px;
    }
    .position_btn {
      margin-left: -4px;
      transform: translateY(-1px);
    }
  }

  .housing_add {
    background: #f4f4f4;
    padding: 20px;
    max-height: 550px;
    overflow: auto;
  }

  .title {
    font-size: 14px;
    color: #333333;
    line-height: 40px;
  }

  .housing_area {
    font-weight: 400;
    font-style: normal;
    font-size: 12px;
    color: #666666;
    line-height: 32px;
    margin-left: 10px;
  }

  .dialog_submit {
    margin-top: 20px;
  }

  .dialog_tag {
    cursor: pointer;
  }

  .line-block {
    display: inline-block;
    vertical-align: middle;
  }
  .g-handle-type{
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 0 10px;
    p{
      width: 48%;
      height: 48px;
      border: 1px dashed #0066ff;
      cursor: pointer;
      text-align: center;
      line-height: 48px;
      font-size: 14px;
      color: #333;
    }
    .p-active{
      position: relative;
      border: 1px solid #0066ff;
      background-color: rgba(0, 153, 255, 0.219607843137255);
      &:after{
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        width: 28px;
        height: 28px;
        background: url("../assets/img/right-jiao.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .p-disabled{
      background-color: #fff;
    }
  }
  .g-glun{
    padding-left: 30px;
    padding-right: 20px;
    max-height: 450px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/switch-company.vue